module.exports = __webpack_public_path__ + "static/img/7111_phase_function_Paper_PointsHejduk_Prediction.f01a767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7111_phase_function_Paper_PointsHejduk_Prediction.png
// module id = AN2N
// module chunks = 0